<div class="bg-metal-50 rounded-lg mobile-full-width py-8 mt-4 px-4 flex flex-col relative">
  <h2 class="pb-2 md:border-bottom text-lg block text-black font-bold">انتخاب اتاق</h2>

  <div (click)="setToggle()"
    class="w-full h-fit p-2 bg-blue-50 border-solid border-2 border-blue-300 rounded-md text-blue-500 md:hidden">
    برای مشاهده قیمت‌های‌ دقیق‌تر، تاریخ ورود و خروج را انتخاب کنید.
  </div>

  <div class="lg:hidden sticky !z-3 top-10 bottom-radius bg-metal-50 py-2">
    <div (click)="setToggle()" class="flex items-center justify-between py-2 px-4 w-full rounded-lg bg-white">
      <div>
        <strong class="text-base font-bold">
          {{autocompleteService._selectedItem().name}}
        </strong>
        <p *ngIf="datePickerService._startDate() && datePickerService._endDate()" class="text-muted text-sm">
          {{datePickerService._startDate()}}
          تا
          {{datePickerService._endDate()}}
        </p>
      </div>
      <i class="ico-Search font-bold text-xl"></i>
    </div>
  </div>
  <iho-pdp-datepicker (goToRooms)="goToRoomSection()" [isShow]="showSearchBar" />
  <div class="w-full bg-[#FF690F] p-2 rounded-lg text-center" *ngIf="isSafarMarket">
    <span class="text-base text-white"> شما از موتور جستجوی </span>
    <span class="text-base text-[#FF690F] bg-white  rounded-lg mx-2 px-2"> سفر مارکت </span>
    <span class="text-base text-white"> به ایران هتل آنلاین هدایت شده‌اید .</span>
  </div>

  <iho-pdp-rooms-filters [resetFilters]="activeFiltersResetTrigger" [dataSource]="_dataSource?.room?.roomFilters!" />

  <div class="flex flex-col gap-4 items-stretch">
    <ng-container *ngIf="filteredRooms?.length &&(
            (_dataSource?.room?.briefPrice?.serviceStatus && _dataSource?.room?.briefPrice?.serviceStatus == 3) ||
            (_dataSource?.room?.briefPrice?.serviceStatus && _dataSource?.room?.briefPrice?.serviceStatus == 4) ||
            !(_dataSource?.room?.briefPrice?.serviceStatus)
        ); else emptyView">
      <ng-container *ngFor="let item of filteredRooms">
        <iho-pdp-rooms-cards [roomId]="item.id" [breakFastType]="_dataSource?.room?.breakfastTypes" [dataSource]="item"
          [packages]="_dataSource?.pakage" [limitCountNightRange]="_dataSource?.limitCountNightRange"
          [limitCountNights]="_dataSource?.limitCountNights || 0"
          [hotelIsFull]="_dataSource?.room?.briefPrice?.serviceStatus == 4"
          (availableDatesClicked)="openDatePicker($event)" />
      </ng-container>
    </ng-container>
  </div>

  <!-- datwepicker overlay deletd class="w-full h-full fixed top-0 left-0 !z-[4]" -->
  <div *ngIf="!datePickerService._allowToShow() && datePickerService._isMobile() === false"
    (click)="closeDatepicker($event)" style="background: rgba(255, 255, 255, 0.5)">
    <div class="iho-datepicker fixed left-[calc(50%+360px)] top-40 z-50">
      <iho-datepicker (triggerSearch)="getRoomsWithNewDate()" />
    </div>
  </div>

  <!-- datwepicker overlay deletd class="w-full h-full fixed top-0 left-0 !z-[4]" -->
  <div *ngIf="!datePickerService._allowToShow() && datePickerService._isMobile() === true"
    (click)="closeDatepicker($event)" style="background: #ffffff;">
    <div class="iho-datepicker w-full  left-0 top-0 z-50">
      <iho-datepicker (triggerSearch)="getRoomsWithNewDate()" />
    </div>
  </div>
</div>

<ng-template #emptyView>
  <iho-pdp-empty-view (resetFilters)="resetFilters()" [similarHotelsLink]="_dataSource?.searchResultCityLink"
    [hasActiveFilter]="!!activeFilters.length" (goToSimilarHotelsSection)="goToSimilarHoptelsSection()"
    [serviceStatus]="_dataSource?.room?.briefPrice?.serviceStatus ?? null" />
</ng-template>